import { Vec3, type CollisionWorld } from '@mindcloudxai/shared';

export type { CollisionWorld } from '@mindcloudxai/shared';

export class NoopCollisionWorld implements CollisionWorld {
  private groundY: number;

  constructor(groundY = 0) {
    this.groundY = groundY;
  }

  setGroundY(groundY: number): void {
    this.groundY = groundY;
  }

  move(_from: Vec3, to: Vec3): Vec3 {
    return Vec3.from(to);
  }

  snapToGround(position: Vec3, eyeHeight: number): Vec3 {
    return new Vec3(position.x, this.groundY + eyeHeight, position.z);
  }
}
